export const RETENTION_DEFAULT_DAY = Object.freeze({
    recording: 30,
    transcript: 365,
    // Quoted because the design's own enum value is the bare word (C14): data, not an identifier.
    "order": 365,
    survey_result: 365,
    caller_detail: 365,
    audit: 730,
});
//# sourceMappingURL=governance.js.map